import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { NotificationManager } from 'Components/Notifications';
import { openModalWithTransaction } from 'Core/views/importResultsModal/redux/slice';

export const useImportNotifications = (sliceSelector, clearNotificationAction) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { importNotification } = useSelector(sliceSelector);
  const handleOpenImportModal = (transactionId, importType, status) => {
    dispatch(openModalWithTransaction({
      transactionId,
      importType,
      status
    }));
  };
  
  useEffect(() => {
    if (importNotification) {
      try {
        const { status, transactionId, importType, error } = importNotification;
        
        if (error) {
          const errorMessage = formatMessage({ id: 'import_notification_parse_error' });
          const errorTitle = formatMessage({ id: 'import_notification_error_title' });
          NotificationManager.error(errorMessage, errorTitle, 0);
        } else {
          const message = formatMessage(
            { id: 'import_notification_message' },
            { transactionId, importType, status }
          );
          
          const titleKey = status === 'SUCCESS' 
            ? 'import_notification_success_title' 
            : 'import_notification_failed_title';
          
          const title = formatMessage({ id: titleKey });

          // Create clickable toast notification
          if (status === 'SUCCESS') {
            NotificationManager.success(
              message, 
              title, 
              10000, 
              () => handleOpenImportModal(transactionId, importType, status),
              null, 
              '', 
              null
            );
          } else {
            NotificationManager.error(
              message, 
              title, 
              0, 
              () => handleOpenImportModal(transactionId, importType, status),
              null, 
              '', 
              null
            );
          }
        }

        // Clear notification after displaying
        dispatch(clearNotificationAction(null));
      } catch (err) {
        console.error('Error processing import notification:', err);
        const errorMessage = formatMessage({ id: 'import_notification_parse_error' });
        const errorTitle = formatMessage({ id: 'import_notification_error_title' });
        NotificationManager.error(errorMessage, errorTitle, 0);
        dispatch(clearNotificationAction(null));
      }
    }
  }, [importNotification, formatMessage, dispatch, clearNotificationAction]);
};